import * as React from 'react'
function SvgCancel(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28.4 5.8L20 14.4l-8.4-8.6-5.8 5.8 8.6 8.4-8.6 8.4 5.8 5.8 8.4-8.6 8.4 8.6 5.8-5.8-8.6-8.4 8.6-8.4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCancel
